import React, { useState } from "react";
import { Document, Page, pdfjs } from "react-pdf";

pdfjs.GlobalWorkerOptions.workerSrc =
  `//cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js`;

export default function PdfViewer({ file, onFileLoad, onTokenSelect }) {
  const [numPages, setNumPages] = useState(0);

  return (
    <div>
      {!file && (
        <input
          type="file"
          accept="application/pdf"
          onChange={(e) => onFileLoad(e.target.files[0])}
        />
      )}

      {file && (
        <Document
          file={file}
          onLoadSuccess={(d) => setNumPages(d.numPages)}
        >
          {Array.from({ length: numPages }).map((_, i) => (
            <Page
              key={i}
              pageNumber={i + 1}
              renderTextLayer
              renderAnnotationLayer={false}
              onClick={(e) => handleTextClick(e, i + 1, onTokenSelect)}
            />
          ))}
        </Document>
      )}
    </div>
  );
}

function handleTextClick(e, page, cb) {
  const selection = window.getSelection();
  if (!selection || !selection.toString()) return;

  cb({
    text: selection.toString(),
    page
  });

  selection.removeAllRanges();
}
